;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	_.extend(Controller.ContactUs.prototype, {

		contactUs: function() {
			// Build layout
			this.start();
			var user = APP.module('instance').user.toJSON(),
				contact_us_model = new Model.ContactUs(),
				contact_us_categories_collection = new Collection.ContactUsCategories();

			contact_us_model.schema.category.options = contact_us_categories_collection.toJSON();

			// Build Form
			var form = new Backbone.Form({
				template: JST.ContactUsIonata,
				model: contact_us_model
			});

			var contactUs = new View.ContactUs({
				model: contact_us_model,
				form: form,
				user: user
			});

			this.view.main.show(contactUs);
		}
	});


}(window, APP, Backbone, Marionette, $, _));